import React, { useState, useEffect } from 'react';
import { Link,useLocation,useHistory} from 'react-router-dom';
import "../../common.css";
import "../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';


const IndexExpiryFormulas = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main" className='warrant-sensitivity Common_warrent index_expiry'>
                <div id="maintable" style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav" className='first_table'>
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}}>Previous Topic</div>
                                            <div className="prevname " style={{textAlign: 'left'}}>Index calls and puts at expiry</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Index calls and puts at expiry</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Index Expiry - Formula</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Call example</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <style dangerouslySetInnerHTML={{__html: "           \n            .contentbox h2{\n  font-family: inherit;\n                font-size:18px;\n                color:#FFDA44;\n                text-align:center;\n            }\n            .formulabox {\n                display:block;\n                padding:0.5em;\n/*                background-color:#404040;*/\n            }\n/*            .imgholder{\n               background-color:#404040;\n            }*/\n        " }} />
                            <div className="contentbox">
                                <p>
                                To calculate the cash settlement amount of index warrants, a settlement level of the underlying index is used. This settlement level can be calculated using one of the following methods:<br /><br />
                                </p>
                                <p>1. The final settlement price of the corresponding index futures contract on the expiry date; or</p>
                                <p>2. The average closing levels of the underlying index for the 5 market days prior to the expiry date; or</p>
                                <p>3. The closing level of the underlying index on the market day prior to the expiry date.<br /><br /></p>
                                <p>Macquarie uses the final settlement price of the corresponding index futures contract on the expiry date to determine the Settlement Price for warrants over the FBM KLCI Index, Hang Seng Index (HSI), Hang Seng TECH Index (HSTECH), S&P 500® Index (SP500), Dow Jones Industrial Average® Index (DJIA) and NASDAQ-100® Index (NDX) at expiry.</p>
                                <p style={{color: '#FFDA44'}}>For iShares FTSE China A50 ETF (“China A50 ETF”) warrants, the settlement price is based on the closing level of its underlying on the market day prior to the expiry date.</p>
                                <p>If the underlying index is not based in Malaysia, the cash settlement amount will need to be converted to Malaysia Ringgit ("MYR"), using the foreign exchange rate taken at 5.00pm on the expiry date.<br /><br />
                                Let’s take a look at the formula that’s used to work out the settlement level for index calls and puts, using the HSI.
                                </p>
                                <h2 className="title">Call Warrant</h2>
                                
                                <div className="formulaholder">
                                <div className="formulabox">
                                    <div className="leqt">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td className="hltxt" style={{height: '39px'}}>    
                                            Value at Expiry =
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>   
                                    <div className="reqt">
                                    <table className="fraction">
                                        <tbody>
                                        <tr><td>(Settlement Level - Exercise Level)</td><td rowSpan={2}>&nbsp;&nbsp;x&nbsp;&nbsp;</td><td rowSpan={2}>FX Rate</td></tr>
                                        <tr><td className="upper_line">Exercise Ratio</td></tr>
                                        </tbody>  
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <h2 className="title">Put Warrant</h2>
                                <div className="formulaholder">
                                <div className="formulabox">
                                    <div className="leqt">
                                    <table cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr>
                                            <td className="hltxt" style={{height: '39px'}}>    
                                            Value at Expiry =
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>   
                                    <div className="reqt">
                                    <table className="fraction" cellSpacing={0} cellPadding={0}>
                                        <tbody>
                                        <tr><td>(Exercise Level - Settlement Level)</td><td rowSpan={2}>&nbsp;&nbsp;x&nbsp;&nbsp;</td><td rowSpan={2}>FX Rate</td></tr>
                                        <tr><td className="upper_line">Exercise Ratio</td></tr>
                                        </tbody>  
                                    </table>
                                    </div>
                                </div>
                                </div>
                                <p>
                                These are similar to the formulas used to calculate the expiry values of single share calls and puts. The difference you would notice is that the final settlement level of HSI Futures is used instead. The formula also includes an additional component in the FX rate, which is to take into consideration the HSI Futures is denominated in a different currency and not MYR.  
                                </p>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                <div className='copyright_sec'>
                Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                    reserved.
                </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                               <Link to="/edu/index-calls/call-example">
                                       <span className="prevname ">Call example</span>
                            </Link>
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/index-calls/call-example">
                            <div className="next right" />
                            </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/index-calls">
                            <div className="prev left" />
                        </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            >
                                <Link to="/edu/index-calls">
                                       <span className="prevname ">	Index calls and puts at expiry</span>
                            </Link>
                                
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
            {/* <div className="dbtn dbtn-seminarbtn">
            <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history}/>
            </div>

        </div>
      );
}
export default IndexExpiryFormulas;